var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"hero-image",attrs:{"alt":_vm.alt,"src":_vm.src},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }